/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { useLocation, useHistory } from 'react-router-dom'
import { Typography, Link, Box, TextField } from '@mui/material'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useTranslation } from 'react-i18next'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import * as localGdeTransactionLite from '../../../services/firestore/localGdeTransactionsLite'
import { getUser, getUserRole } from '../../../redux/global'
import { userRoleAdmin, userRoleSuperUser } from '../../../common/constants'
import ImageContainer from './MultiImageContainer'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { useMergeState } from 'irmlib/hooks'
import { MaterialReactTable } from 'material-react-table'
import ExportCsv from '../../Controls/ExportCsv'
import { MenuButton } from '../../../irmlib/src/components/Controls'
import { MoreVert } from 'irmlib/icons'
import { useTheme } from '../../../irmlib/src/styles'
import { Dialog, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from '@material-ui/core'
import { ReprocessImage, RetakeImageBox, UpdateImageTemplate, UpdateImageTemplateAndRef, UpdateImgRefImage } from './LocalMenuActivities'
import { Visibility } from '@material-ui/icons'
// import { getNatsURLForRefAndImgs } from '../../../services/nats/localNatsTransactions'
import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import * as constants from '../../../irmlib/src/common/constants.js'



const initialState = {
  images: []
}

const LocalBoxImageDetails = () => {
  const location = useLocation()
  const theme = useTheme()
  const history = useHistory()
  const requestId = location.pathname.split('/')[3]
  const boxId = location.pathname.split('/')[4]
  const activityId = location.pathname.split('/')[5]
  const { t } = useTranslation()
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  const [wmsCode, setWmsCode] = useState('')
  const [assetType, setAssetType] = useState('')
  const [enableOptions, setEnableOptions] = useState(false)
  const [imagesRawData, setImagesRawData] = useState([])
  const [selectedRefImage, setSelectedRefImage] = useState(null)
  const [selectedImages, setSelectedImages] = useState([])
  const [selectedImageIndex, setSelectedImageIndex] = useState(null) 
  const [isLoading, setIsLoading] = useState(false)
  const [openReprocessImage, setOpenReprocessImage] = useState(false)
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [retakeImage, setRetakeImage] = useState(false)
  const [openChangeRefImg, setOpenChangeRefImg] = useState(false)
  const [openChangeTempAndRefImg, setOpenChangeTempAndRefImg] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [, setState, getState] = useMergeState(initialState)  
  const [loadingImage, setLoadingImage] = useState(false)
  const [imageError, setImageError] = useState(false)
  const [isLoadingImages, setIsLoadingImages] = useState(false)
  // const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)

  useEffect(async () => {
    getRequestDetails()
    const subscribeImagesListener = await localGdeTransactions.imagesListner(setImagesRawData, activityId)
    return () => subscribeImagesListener()
  }, [])

  useEffect(() => {
    getImages()
  }, [imagesRawData])

  const convertUTCDateToLocalDate = (date) => {
    const date2 = new Date(date)
    const dateString = date2.toLocaleDateString()
    const timeString = date2.toLocaleTimeString()
    const newDate = `${dateString}, ${timeString}`
    return newDate
  }

  const parseLocaleDateToYMD = (localeDateString) => {
    const date = new Date(localeDateString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const menuItems = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
    { value: 'Reprocess Image', label: t('Search.ReprocessImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template', label: t('Search.ChangeTemplate'), style: { color: theme.palette.primary.main } },
    { value: 'Change Reference Image', label: t('Search.ChangeRefImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template And Reference Image', label: t('Search.ChangeTemplateAndRefImage'), style: { color: theme.palette.primary.main } },
  ]
  const menuItems2 = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
  ]
  // Columns for Images
  const columnsImage = [
    {
      header: t('tableColumns.boxId'),
      accessorKey: 'boxId',
      enableFiltering: false, // Matches filter: false
    },
    {
      header: t('tableColumns.barcode'),
      accessorKey: 'barCode',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.status'),
      accessorKey: 'status',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      accessorKey: 'formatError',
      header: t('tableColumns.format'),
    },
    {
      header: t('tableColumns.idpStatus'),
      accessorKey: 'idpStatus',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.idpException'),
      accessorKey: 'exception',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('smartCatalog.imgException'),
      accessorKey: 'exceptionNote',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.isProcessed'),
      accessorKey: 'isProcessed',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.assetType'),
      accessorKey: 'assetType',
      enableFiltering: false,
    },
    {
      header: t('reports.employeeLevel.employee'),
      accessorKey: 'userName',
      enableFiltering: false,
    },
    {
      header: t('tableColumns.createdTime'),
      accessorKey: 'createdTS',
      enableFiltering: true,
      filterVariant: 'custom',
      customFilterLogic: (value, filter) => {
        if (filter && filter.length > 0) {
          const localeDatePart = value.split(' ')[0]
          const datePart = parseLocaleDateToYMD(localeDatePart)
          return datePart !== filter[0]
        }
        return false
      },
      customFilterDisplay: (filterList, onChange, index, column) => (
        <TextField
          label={t('dashBoard.selectDate')}
          type="date"
          value={filterList[index] || ''}
          onChange={(event) => {
            const value = event.target.value
            filterList[index] = value === '' ? [] : [value]
            onChange(filterList[index], index, column)
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },
    {
      accessorKey: 'images',
      header: t('tableColumns.images'),
      Cell: ({ row }) => {
        const rowData = row?.original?.images
        if (rowData && rowData?.length !== 0) {
          return (
            <Visibility
              style={{ cursor: 'pointer', fontSize: 32 }}
              onClick={() => {
                handleOpen(0, rowData)
              }} 
            />
          )
        } else {
          return null
        }
      }
    },
    {
      header: t('smartCatalog.sequenceId'),
      accessorKey: 'sequenceId',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
      sortingFn: (rowA, rowB) => {
        const valueA = rowA.original.sequenceId === '-' ? Infinity : rowA.original.sequenceId
        const valueB = rowB.original.sequenceId === '-' ? Infinity : rowB.original.sequenceId
        return valueA - valueB
      },
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
    },
    {
      header: t('smartCatalog.range'),
      accessorKey: 'range',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
    },
    {
      header: t('tableColumns.imgReference'),
      accessorKey: 'imgReference',
      Cell: ({ row }) => {
        const refImage = row?.original?.currentImageURL
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.7
              }
            }}
            onClick={() => handleImageClick(refImage)}
          >
            <Visibility 
              style={{ 
                cursor: 'pointer', 
                fontSize: 32,
              }} 
            />
          </Box>
        )
      }
    },
    {
      header: t('tableColumns.templateFields'),
      accessorKey: 'templateFields',
      size: 700,
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          minWidth: 2800,
        },
      },
      Cell: ({ row }) => {
        const rowData = row?.original?.templateFields
        return (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '4px', whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}>
            {rowData.map((field, index) => (
              <div
                key={index}
                style={{
                  padding: '0px 20px 0px 0px',
                  wordBreak: 'break-word',
                  width: '100%',
                  whiteSpace: 'pre-wrap'
                }}
              >
                {field}
              </div>
            ))}
          </div>
        )
      }
    },
    enableOptions && getUser().role === 'SUPER USER'
      ? {
          accessorKey: 'modify',
          header: t('tableColumns.action'),
          Cell: ({ row }) => {
            const rowData = getState()?.images[row?.index]
            if (!rowData) return null
            const statuses = rowData?.status
            const upload = t(`jobStatusObj.${'uploaded'}`)
            const isReprocess = rowData?.isReprocess ?? false
            let customMenuItems = []
            if (rowData && 
              (
                (rowData?.isProcessed === 'false' && rowData?.isPublished === 'true') || 
                (['pending', 'In Progress'].includes(rowData?.boxStatus)) ||
                (isReprocess)
              )) {
              customMenuItems = menuItems2
            } else {
              customMenuItems = menuItems
            }
            if (!statuses?.includes(upload)) {
              return (
                <MenuButton
                  id={'allJobs_ellipsis'}
                  buttonIcon={<MoreVert />}
                  rowdata={rowData}
                  items={customMenuItems}
                  onSelect={(value) => { onSelect(value, rowData) }}
              />
              )
            } else {
              return null
            }
          }
        }
      : null
  ].filter(Boolean)

  if (wmsCode === 'SKP' || assetType.includes('Box')) {
    const indexOfwmsStatusColumn = columnsImage.findIndex(column => column.accessorKey === 'barCode')
    if (indexOfwmsStatusColumn !== -1) {
      columnsImage.splice(indexOfwmsStatusColumn, 1)
    }
  }

  const columnsWithWidths = columnsImage.map((col) => {
    const headerLength = col.header.length
    let minWidth = 0
    if (headerLength < 8) {
      minWidth = headerLength * 8
    } else {
      minWidth = headerLength * 15
    }

    return {
      ...col,
      minSize: minWidth,
      muiTableHeadCellProps: {
        sx: {
          whiteSpace: 'nowrap',
          wordWrap: 'break-word',
          minWidth: `${minWidth}px`,
          overflow: 'visible',
          color: '#58595B',
          fontWeight: 'bold',
        },
      },
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',

        }
      },
    }
  })

  const handleImageClick = async (imgReference) => {
    setLoadingImage(false)
    setImageError(false)
    setSelectedRefImage(null)
    
    if (!imgReference) {
      setImageError(true)
      setLoadingImage(false)
      setSelectedRefImage(null)
      return
    }
    
    // Handle array format
    const imageRef = Array.isArray(imgReference) ? imgReference[0] : imgReference
    
    if (!imageRef || imageRef === '' || imageRef === '-') {
      setImageError(true)
      setLoadingImage(false)
      setSelectedRefImage(null)
      return
    }
    
    // --- OLD CODE ---
    // if (imageCache.current.has(imageRef)) {
    //   const cachedImage = imageCache.current.get(imageRef)
    //   if (cachedImage) {
    //     isDialogOpenRef.current = true
    //     setSelectedRefImage(cachedImage)
    //     setLoadingImage(false)
    //     setImageError(false)
    //     return
    //   }
    // }
    
    isDialogOpenRef.current = true
    setLoadingImage(true)
    setSelectedRefImage(null) 
    setImageError(false)
    
    try {
      const imageUrl = await loadImageFromNats(imageRef)
      if (isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedRefImage(imageUrl) 
          setImageError(false)
        } else {
          setSelectedRefImage(null) 
          setImageError(true)
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isDialogOpenRef.current) {
        setSelectedRefImage(null) 
        setImageError(true)
      }
    } finally {
      if (isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null
    
    return await getImgFromNats(
      constants.LOCAL_NATS_SERVER,
      constants.LOCAL_AI_REF_IMG,
      imgReference,
      true // Enable caching
    )

    // --- OLD CODE ---
    // if (imageCache.current.has(imgReference)) {
    //   return imageCache.current.get(imgReference)
    // }
    // 
    // if (!imgReference.includes('nats')) {
    //   if (imgReference.startsWith('http://') || 
    //       imgReference.startsWith('https://') || 
    //       imgReference.startsWith('data:')) {
    //     imageCache.current.set(imgReference, imgReference)
    //     return imgReference
    //   }
    //   return null
    // }
    // 
    // if (imgReference.includes('nats')) {
    //   try {
    //     const imageUrl = await natsService.getImgFromNats(
    //       constants.LOCAL_NATS_SERVER, 
    //       constants.LOCAL_AI_REF_IMG, 
    //       imgReference
    //     )
    //     if (imageUrl) {
    //       imageCache.current.set(imgReference, imageUrl)
    //       return imageUrl
    //     }
    //   } catch (error) {
    //     console.error('Error loading image from NATS:', error)
    //     return null
    //   }
    // }
    // 
    // return null
  }

  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false
    setSelectedRefImage(null) 
    setLoadingImage(false)
    setImageError(false)
  }

  const getRequestDetails = async () => {
    try {
      const request = await localGdeTransactionLite.getRequestById(requestId)
      setWmsCode(request?.wmsCode)
      setAssetType(request?.assetType)
      const userRole = getUserRole()
      if (userRole === userRoleAdmin || userRole === userRoleSuperUser) {
        setEnableOptions(true)
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    }
  }

  const getImages = async () => {
    try {
      setIsLoading(true)
      const imagesFormattedData = []

      const uniqueActivityIds = [...new Set(imagesRawData.map(data => data.activityId))]
      const activityStatusPromises = uniqueActivityIds.map(actId =>
        localGdeTransactions.getActivityByID(actId)
          .then((res) => ({
            activityId: actId,
            status: res.status
          }))
          .catch((error) => {
            console.error(`Error fetching activity ${actId}:`, error)
            return { activityId: actId, status: null }
          })
      )

      const allData = await Promise.all(activityStatusPromises)
      const eachBoxStatus = {}
      // const templateFieldKeys = []
      allData.forEach(e => {
        eachBoxStatus[e.activityId] = e.status
      })
      imagesRawData && imagesRawData.forEach((data) => {
        const timestamp = convertUTCDateToLocalDate(data?.createdTS)
        const rangeFromTo = data?.rangeFrom !== undefined && data?.rangeTo !== undefined
          ? `${data?.rangeFrom} - ${data?.rangeTo}`
          : '-'
        const format = data?.formatError !== undefined ? data?.formatError : '-'
        let formatString
        if (format === '-') {
          formatString = '-'
        } else {
          formatString = format ? 'Yes' : 'No'
        }
        let templateFields
        const template = data?.template
        const refImg = data?.imgReference

        if (template) {
          // const fields = template
          templateFields = Object.keys(template).map((key) => {
            const data = `${key} (${template[key].fieldId})`
            return data
          })
        }
        imagesFormattedData.push({
          activityId: data.activityId,
          imageId: data.id,
          boxId: data.skpBoxNbr,
          barCode: data?.barcode || '-',
          createdTS: timestamp,
          assetType: data.assetType,
          isProcessed: data.isProcessed.toString(),
          isPublished: data.isPublished.toString(),
          // customTemplateName: data.customTemplateName,
          // status: data.status,
          status: t(`jobStatusObj.${data?.status}`),
          image: '',
          images: data.imgDetails?.imgPath,
          userName: data?.username,
          sequenceId: data?.sequenceId || '-',
          range: rangeFromTo,
          formatError: formatString,
          idpStatus: data?.idp?.status,
          exception: data?.idp?.exception,
          exceptionNote: data?.exceptionNote,
          currentImageURL: refImg,
          customer: data?.accountLevel1,
          boxStatus: eachBoxStatus[data.activityId],
          isReprocess: data?.isReprocess,
          templateFields: templateFields
        })
      })
      // await getNatsURLForRefAndImgs(imagesFormattedData, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
      // REMOVED: Don't load images upfront - load only on click
      // await natsService.getNatsURLForRefAndImgs(imagesFormattedData, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
      setState({ images: imagesFormattedData })
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleGoBack = () => {
    history.goBack()
  }

  // Breadcrumbs
  const breadcrumbs = [
    <Link key="breadcrumb-1" underline='hover' onClick={() => handleGoBack()} color='primary' style={{ cursor: 'pointer' }}>
      {t('demo.requestId')}
    </Link>,
    <Link key="breadcrumb-2" underline='hover' onClick={() => handleGoBack()} color='primary' style={{ cursor: 'pointer' }}>
      {requestId}
    </Link>,
    <Link key="breadcrumb-3" underline='none' color='inherit'>
      {t('tableColumns.boxId')}
    </Link>,
    <Typography key="breadcrumb-4" sx={{ color: 'text.primary' }}>
      {boxId}
    </Typography>,
  ]

  const BreadCrumbsComponent = () => {
    return (
      <Breadcrumbs separator='›' aria-label='breadcrumb'>
        {breadcrumbs}
      </Breadcrumbs>
    )
  }

  const getBlobImage = async (images = []) => {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return []
    }

    const result = await Promise.all(images.map(async image => {
      if (image && typeof image === 'string' && image.includes('nats')) {
        // Use LOCAL_AI_ASSET_IMG for regular captured images, not reference images
        // const blobUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, image)
        const blobUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, image)
        return blobUrl || image
      }
      return image
    }))
    return result.filter(img => img !== null && img !== undefined) // Filter out any null/undefined values
  }

  const handleOpen = async (index, images) => {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return
    }

    setIsLoadingImages(true)
    setSelectedImageIndex(index)

    try {
      const convertedImages = await getBlobImage(images)
      setSelectedImages(convertedImages) 
    } catch (error) {
      console.error('Error converting images', error)
      setSelectedImages(images) 
    } finally {
      setIsLoadingImages(false)
    }
  }
  
  const handleClose = () => {
    setSelectedImageIndex(null)
    setSelectedImages([]) 
    setIsLoadingImages(false)
  }

  const MultiImageContainer = () => (
    <div>
      {selectedImageIndex !== null && (
        <ImageContainer
          images={selectedImages}
          selectedImageIndex={selectedImageIndex}
          handleClose={handleClose}
          isLoading={isLoadingImages}
        />
      )}
    </div>
  )

  const handleRetakeImage = (rowData) => {
    setSelectedRowData(rowData)
    setRetakeImage(true)
  }

  const handleCloseRetakeImageModal = () => {
    setRetakeImage(false)
    setSelectedRowData(null)
  }

  const handleOpenMenuItems = (rowData) => {
    setSelectedRowData(rowData)
    setOpenReprocessImage(true)
  }

  const handleCloseMenuItems = () => {
    setOpenReprocessImage(false)
    setSelectedRowData(null)
  }

  const handleOpenTemplateModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenTemplateModal(true)
  }

  const handleCloseTemplateModal = () => {
    setOpenTemplateModal(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeRefImg(true)
  }
  const handleCloseRefImgModal = () => {
    setOpenChangeRefImg(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgAndTempModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeTempAndRefImg(true)
  }
  const handleCloseRefImgandTempModal = () => {
    setOpenChangeTempAndRefImg(false)
    setSelectedRowData(null)
  }

  const RefImageDialog = () => {
    const isOpen = loadingImage || !!selectedRefImage || imageError
    
    if (!isOpen) return null
    
    return (
      <Dialog 
        open={isOpen}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <DialogContentText component="div">
            {loadingImage && !selectedRefImage && !imageError
              ? <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <CircularProgress size={40} />
                <Typography variant="body2" color="textSecondary">
                  {t('Search.loading')}
                </Typography>
              </Box>
              : selectedRefImage && !imageError
                ? <img
                  src={selectedRefImage}
                  alt="Reference Image"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'block',
                    margin: '0 auto'
                  }}
                  onError={() => {
                    setSelectedRefImage(null) 
                    setLoadingImage(false)
                    setImageError(true)
                  }}
                />
                : <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '400px',
                  minWidth: '400px',
                  gap: 2
                }}>
                  <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center' }}>
                    {t('smartCatalog.imageNotAvailable')}
                  </Typography>
                </Box>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  // Action column select options
  const onSelect = (value, rowData) => {
    rowData.requestId = requestId
    if (value === 'Retake Image') {
      handleRetakeImage(rowData)
    }
    if (value === 'Reprocess Image') {
      handleOpenMenuItems(rowData)
    }
    if (value === 'Change Template') {
      handleOpenTemplateModal(rowData)
    }
    if (value === 'Change Reference Image') {
      handleOpenRefImgModal(rowData)
    }
    if (value === 'Change Template And Reference Image') {
      handleOpenRefImgAndTempModal(rowData)
    }
  }

  return (
    <MainRouteSubRoutePage
      mainTitle={t('routeTitles.imageDetails')}
      subTitle={<><GoBackSubtitle id={'BoxImageDetails_goBack'} />
        <BreadCrumbsComponent /></>}
    >
      <Box boxShadow={2} borderRadius={4}>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
          <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
            {t('demo.viewImgDetails')}
          </Typography>
        </div>
        <MaterialReactTable
          columns={columnsWithWidths}
          data={getState()?.images}
          state={{ showSkeletons: isLoading }}
          enableColumnFilters={true}
          enableRowSelection
          enableExport={true}
          enableGlobalFilter
          enableColumnFilter
          enableColumnSorting
          enableRowVirtualization={true}
          enablePagination={true}
          enableGrouping={true}
          enableColumnResizing={true}
          initialState={{
            density: 'compact',
            sorting: [
              {
                id: 'boxId',
                desc: false,
              },
              {
                id: 'sequenceId',
                desc: false,
              }
            ],
            columnVisibility: { images: true, modify: true },
          }}
          renderTopToolbarCustomActions={({ table, data }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = getState()?.images?.length === 0
            const isNoPageData = getState()?.images?.length > 4
            return (
              <ExportCsv
                columns={columnsImage}
                isDisabled={isDisabled}
                isNoData={isNoData}
                isNoPageData={isNoPageData}
                table={table}
              />
            )
          }}
          tableFor={'Box_ImageDetails'}
        /></Box>
      <MultiImageContainer />
      <RefImageDialog />
      {retakeImage && <RetakeImageBox rowData={selectedRowData} onClose={handleCloseRetakeImageModal} />}
      {openReprocessImage && <ReprocessImage rowData={selectedRowData} onClose={handleCloseMenuItems} />}
      {openTemplateModal && <UpdateImageTemplate rowData={selectedRowData} onClose={handleCloseTemplateModal} />}
      {openChangeRefImg && <UpdateImgRefImage rowData={selectedRowData} onClose={handleCloseRefImgModal} />}
      {openChangeTempAndRefImg && <UpdateImageTemplateAndRef rowData={selectedRowData} onClose={handleCloseRefImgandTempModal} />}
    </MainRouteSubRoutePage>
  )
}

export default LocalBoxImageDetails
